<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div class="cascade-wrapper" slot="body">
        <FormItem prop="value" :rules="rules">
          <!-- pc端 -->
          <div v-if="windowType === 'pc'" class="cascade-box">
            <el-cascader
              v-model="value"
              separator=","
              popper-class="custom-cascade"
              :title="config.textValue"
              :options="langOptionList"
              :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect)"
              :props="{
                label: 'value',
                value: 'id'
              }"
              @change="handleChange"></el-cascader>
          </div>
          <!-- 手机端 -->
          <div v-if="windowType === 'mobile'" class="cascade-box">
            <div class="select-box" @click="showAddress">
              <span v-if="!fieldValue" class="tips">{{cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect)}}</span>
              <span v-else class="txt">{{ fieldValue }}</span>
              <van-icon name="arrow-down" />
            </div>
            <van-popup v-model="show" get-container=".answer-wrap" safe-area-inset-bottom round position="bottom">
              <van-cascader
                v-model="cascaderValue"
                :title="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect)"
                :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect)"
                :options="langOptionList"
                :field-names="fieldNames"
                active-color="#05C6AF"
                @close="show = false"
                @change="onChange"
                @finish="onFinish"
              />
              <div class="action-btn">
                <van-button :disabled="disabledSelect" color="#4CBAA2" type="primary" @click="confirmSelect">{{cvtLang('btnConfirm', surveyInfoLang.btnConfirm)}}</van-button>
              </div>
            </van-popup>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
export default {
  name: 'CascadeBoxAnswer',
  props: ['config'],
  data () {
    return {
      value: '',

      show: false,
      cascaderValue: '',
      fieldValue: '',
      disabledSelect: true,
      fieldNames: {
        text: 'value',
        value: 'id',
        children: 'children',
      },
      stashSelectedOptions: [],

      inited: false,
      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {
    'config.value' (newVal) {
      if (!newVal.length) {
        this.fieldValue = ''
        this.value = ''
      }
    }
  },
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
    }),
    langOptionList() {
      let arr = this.cvtLang(this.config.id + 'optionList', this.config.optionList)
      let res
      if (Array.isArray(arr)) {
        res = arr
      } else {
        res = JSON.parse(arr)
      }
      if (this.config.value && this.config.value.length) {
        this.fieldValue = this.config.value.map(item => (this.getTreeName(res, item).value)).join(',')
      }
      // 手机端需过滤掉选项为disabled的选项
      if (this.windowType === 'mobile') {
        res = this.filterList(res)
      }
      return res
    }
  },
  methods: {
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    filterList(res) {
      return res.filter(item => {
        return !item.disabled
      }).map(item => {
        item = Object.assign({}, item)
        if (item.children) {
          item.children = this.filterList(item.children)
        }
        return item
      })
    },
    getTreeName(treeList, id) {
      for (let i=0; i<treeList.length; i++) {
        let treeItem = treeList[i]
        if (treeItem.id === id) {
          return treeItem
        } else {
          if (treeItem.children && treeItem.children.length) {
            let res = this.getTreeName(treeItem.children, id)
            if (res) {
              return res
            }
          }
        }
      }
    },
    handleChange(value) {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      this.config.value = value
      this.config.textValue = value.map(item => (this.getTreeName(this.config.optionList, item).value)).join(',')
    },
    // 展示地址
    showAddress() {
      this.show = true
    },
    onChange() {
      this.disabledSelect = true
    },
    onFinish({ selectedOptions }) {
      this.disabledSelect = false
      this.stashSelectedOptions = selectedOptions
    },
    confirmSelect() {
      this.show = false
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      this.fieldValue = this.stashSelectedOptions.map((option) => option.value).join(',')
      this.config.value = this.stashSelectedOptions.map(item => (item.id))
      this.config.textValue = this.config.value.map(item => (this.getTreeName(this.config.optionList, item).value)).join(',')
    }
  },
  created () {
  },
  mounted () {
    if (this.windowType === 'mobile') {
      if (this.config.textValue) {
        // 如果有值则默认选中
        this.cascaderValue = this.config.value[this.config.value.length - 1]
      }
    } else {
      this.value = this.config.value
    }
  }
}
</script>
<style lang="scss" scoped>
  .dtl {
    margin-top: 18px;
  }
  .cascade-wrapper {
    min-height: 140px;
    .cascade-box {
      display: flex;
      padding: 30px 0;
      .select-box {
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #ccc;
        padding: 0 16px;
        border-radius: 4px;
        .txt {
          overflow:hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
          width:100%;
          max-width: 70vw;
          display: inline-block;
        }
        .tips {
          color: #bbb;
        }
        .van-icon {
          color: #ccc;
        }
      }
      .el-select, .el-cascader {
        margin-right: 10px;
        flex: 1;
        &:last-child {
          margin-right: 0px;
        }
        >>> .el-input__inner {
          height: auto;
          line-height: inherit;
          font-size: inherit;
          border: 1px solid #D5DBE6;
          padding: 0px 10px;
          background: none;
          color: #333;
          font-weight: 400;
        }
        >>> .el-input__suffix {
          font-size: initial;
          color: #bbb;
          top: 0px;
          right: 5px;
        }
      }
    }
  }
  .answer-pc {
    .cascade-wrapper {
      min-height: 70px;
      .cascade-box {
        padding: 15px 0;
        .el-select, .el-cascader {
          >>> .el-input__inner {
            line-height: 32px;
          }
        }
      }
    }
  }
  >>> .van-cascader {
    .van-cascader__options {
      height: 60vh;
    }
  }
  .action-btn {
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    padding: 10px 0;
    .van-button {
      width: 90%;
    }
  }
</style>
<style lang="scss">
.custom-cascade {
  .el-cascader-panel {
    max-width: calc(900px - 212px);
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/CascadeBox/CascadeBoxAnswer.vue